import type { TOptions } from 'i18next';
import { i18n } from '@/i18n';

const KNOWN_NAMESPACES = new Set([
  'toast', 'common', 'errors', 'validation', 'auth', 'workflow', 'hr', 'finance', 'crm', 'desk', 'procurement',
  'identity', 'leadgen', 'marketing', 'onboarding', 'projects', 'social', 'warehouse', 'org', 'master', 'work', 'auth', 'pos',
]);

export type ToastTranslateOptions = TOptions & { ns?: string };

/**
 * Resolves a toast message from an i18n key or returns the literal when no key matches.
 * Keys without a namespace prefix use the `toast` namespace.
 */
export function translateToast(keyOrMessage: string, options?: ToastTranslateOptions): string {
  if (!i18n.isInitialized) {
    return keyOrMessage;
  }

  const params = options ?? {};
  const explicitNs = params.ns;

  if (explicitNs) {
    return i18n.t(keyOrMessage, { ...params, ns: explicitNs, defaultValue: keyOrMessage });
  }

  if (keyOrMessage.includes('.')) {
    const dot = keyOrMessage.indexOf('.');
    const maybeNs = keyOrMessage.slice(0, dot);
    if (KNOWN_NAMESPACES.has(maybeNs)) {
      const subKey = keyOrMessage.slice(dot + 1);
      return i18n.t(subKey, { ...params, ns: maybeNs, defaultValue: keyOrMessage });
    }
    return i18n.t(keyOrMessage, { ...params, defaultValue: keyOrMessage });
  }

  return i18n.t(keyOrMessage, { ...params, ns: 'toast', defaultValue: keyOrMessage });
}
